module.exports = __webpack_public_path__ + "img/about-hotels.5a0beff6.svg";